import "reflect-metadata";
import {inject, injectable} from "inversify";
import {ChatRepository} from "@dropDesk/domain/repositories/chat/chat.repository";
import {ListPaginationChatMessagesEntity} from "@dropDesk/domain/entities/chat/list_pagination_chat_messages.entity";

@injectable()
export class NavigateToMessageV2UseCase {
    private _repository: ChatRepository;

    constructor(@inject(ChatRepository) repository: ChatRepository) {
        this._repository = repository;
    }

    public call(id: string, limit: number): Promise<ListPaginationChatMessagesEntity> {
        return this._repository.navigateToMessageV2(id, limit);
    }
}
